type UseCaseSceneSlugProps = {
  sceneNumber?: string;
  sceneLabel?: string;
};

export function UseCaseSceneSlug({ sceneNumber, sceneLabel }: UseCaseSceneSlugProps) {
  if (!sceneNumber && !sceneLabel) return null;

  return (
    <div className="uc-scene-slug reveal">
      {sceneNumber && <span className="uc-scene-num">{sceneNumber}</span>}
      {sceneNumber && sceneLabel && <span className="uc-scene-bar" aria-hidden="true" />}
      {sceneLabel && <span className="uc-scene-label">{sceneLabel}</span>}
    </div>
  );
}
